const TaxCalculatorForm = {
  AK: {
    name: 'Alaska',
    short: 'AK',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 39700,
        label: 'AK UI Tax (Employer)',
        tip: "State unemployment tax is a percent of taxable wages up to $39,700.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: 'Most employers typically pay 0.60% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 5.40% reduction, which brings the total rate to 0.60%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
    ],
  },
  AL: {
    name: 'Alabama',
    short: 'AL',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        limit: 118000,
        rate: 0.062,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 8000,
        label: 'AL Unemployment Tax',
        tip: "State unemployment tax is a percent of taxable wages up to $8,000.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'constant',
        value: 4.8,
        label: 'Employment Security Enhancement Assessment (ESA)',
        tip: 'The ESA supports programs that help people on unemployment get a new job. It is in addition to the regular UI tax/contribution and is 0.06% of taxable wages up to $8,000.00.',
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: 'Most employers typically pay 0.60% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 5.40% reduction, which brings the total rate to 0.60%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
    ],
  },
  AR: {
    name: 'Arkansas',
    short: 'AR',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 12000,
        label: 'AR Unemployment Tax',
        tip: "State unemployment tax is a percent of taxable wages up to $12,000.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: 'Most employers typically pay 0.60% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 5.40% reduction, which brings the total rate to 0.60%. This is only paid on the first $7,000.00 of wages.',
      },
    ],
  },
  AZ: {
    name: 'Arizona',
    short: 'AZ',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 7000,
        label: 'AZ Unemployment Tax',
        tip: "State unemployment tax is a percent of taxable wages up to $7,000.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: 'Most employers typically pay 0.60% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 5.40% reduction, which brings the total rate to 0.60%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
    ],
  },
  CA: {
    name: 'California',
    short: 'CA',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 7000,
        label: 'CA - CA SUI',
        tip: "State unemployment tax is a percent of taxable wages up to $7,000.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.021,
        label: 'FUTA',
        tip: 'Most employers typically pay 2.10% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 3.90% reduction, which brings the total rate to 2.10%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
      {
        type: 'rate',
        rate: 0.001,
        label: 'CA ETT',
        tip: 'The California Employment Training Tax is 0.1% of taxable wages up to $7000.00.',
        limit: 7000,
      },
    ],
  },
  CO: {
    name: 'Colorado',
    short: 'CO',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 12200,
        label: 'CO Unemployment Insurance Tax',
        tip: "State unemployment tax is a percent of taxable wages up to $12,000.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: 'Most employers typically pay 0.60% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 5.40% reduction, which brings the total rate to 0.60%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
      {
        type: 'additional',
        label: 'CO Local Taxes',
        tip: 'OPT taxes in Colorado are paid to certain cities in which an employee works.',
      },
    ],
  },
  CT: {
    name: 'Connecticut',
    short: 'CT',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 15000,
        label: 'Connecticut State Unemployment Tax',
        tip: "State unemployment tax is a percent of taxable wages up to $15,000.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.027,
        label: 'FUTA',
        tip: 'Most employers typically pay 2.70% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 3.30% reduction, which brings the total rate to 2.70%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
    ],
  },
  DC: {
    name: 'District of Columbia',
    short: 'DC',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 9000,
        label: 'DC Unemployment Compensation Tax',
        tip: "State unemployment tax is a percent of taxable wages up to $9,000.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: 'Most employers typically pay 0.60% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 5.40% reduction, which brings the total rate to 0.60%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
      {
        type: 'rate',
        rate: 0.002,
        label: 'DC Admin. Assessment',
        tip: "DC Admin. Assessment. This tax supports the administration of the District's Unemployment Insurance (UI) Program. It is in addition to the regular UI tax/contribution and is 0.2% of taxable wages up to $9,000.00.",
        limit: 9000,
      },
    ],
  },
  DE: {
    name: 'Delaware',
    short: 'DE',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 18500,
        label: 'DE Unemployment Insurance',
        tip: "State unemployment tax is a percent of taxable wages up to $18,500.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: 'Most employers typically pay 0.60% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 5.40% reduction, which brings the total rate to 0.60%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
      {
        type: 'rate',
        rate: 0.00085,
        label: 'DE Training Tax',
        tip: 'The Training Tax is a component of Unemployment Insurance (UI) tax that funds training programs in the state of Delaware. It is 0.085% of taxable wages up to $18,500.00.',
        limit: 18500,
      },
      {
        type: 'additional',
        label: 'DE Local Taxes',
        tip: "The Head Tax is an employer-paid tax that supports the City of Wilmington's General Fund. This is applicable if your employee works in the City of Wilmington.",
      },
    ],
  },
  FL: {
    name: 'Florida',
    short: 'FL',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 7000,
        label: 'Florida State Unemployment Tax',
        tip: "State unemployment tax is a percent of taxable wages up to $7,000.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: 'Most employers typically pay 0.60% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 5.40% reduction, which brings the total rate to 0.60%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
    ],
  },
  GA: {
    name: 'Georgia',
    short: 'GA',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 9500,
        label: 'GA State Unemployment Tax',
        tip: "State unemployment tax is a percent of taxable wages up to $9,500.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: 'Most employers typically pay 0.60% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 5.40% reduction, which brings the total rate to 0.60%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
      {
        type: 'rate',
        rate: 0.0008,
        label: 'GA Administrative Assessment Tax',
        tip: 'The Administrative Assessment Tax funds administrative improvements for Georgia Employer Services. It is mandatory and is 0.08% of taxable wages up to $9,500.00.',
        limit: 9500,
      },
    ],
  },
  HI: {
    name: 'Hawaii',
    short: 'HI',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 42200,
        label: 'HI UI Contribution',
        tip: "State unemployment tax is a percent of taxable wages up to $42,200.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: 'Most employers typically pay 0.60% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 5.40% reduction, which brings the total rate to 0.60%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
      {
        type: 'rate',
        rate: 0.0001,
        label: 'HI E&T Assessment',
        tip: 'The Employment & Training (E&T) Assessment funds training and retraining programs that assist workers who have become recently unemployed or are likely to be unemployed. It is 0.01% of taxable wages up to $42,200.00',
        limit: 42200,
      },
    ],
  },
  IA: {
    name: 'Iowa',
    short: 'IA',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 28300,
        label: 'IA Unemployment Insurance Tax',
        tip: "State unemployment tax is a percent of taxable wages up to $28,300.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: 'Most employers typically pay 0.60% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 5.40% reduction, which brings the total rate to 0.60%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
    ],
  },
  ID: {
    name: 'Idaho',
    short: 'ID',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 37200,
        label: 'ID State Unemployment Tax',
        tip: "State unemployment tax is a percent of taxable wages up to $37,200.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: 'Most employers typically pay 0.60% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 5.40% reduction, which brings the total rate to 0.60%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
      {
        type: 'additional',
        label: 'ID Admin. Reserve Fund Tax',
        tip: 'This tax is a component of overall Unemployment Tax that supports the Administrative Reserve Fund.',
      },
      {
        type: 'additional',
        label: 'ID Workforce Development Tax',
        tip: 'This tax is a component of overall Unemployment Tax that supports the Workforce Development Training Fund to reimburse employee training costs to eligible companies that are expanding jobs and job skills.',
      },
    ],
  },
  IL: {
    name: 'Illinois',
    short: 'IL',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 12960,
        label: 'IL SUTA',
        tip: "State unemployment tax is a percent of taxable wages up to $12,960.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: 'Most employers typically pay 0.60% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 5.40% reduction, which brings the total rate to 0.60%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
    ],
  },
  IN: {
    name: 'Indiana',
    short: 'IN',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 9500,
        label: 'IN SUTA Premiums',
        tip: "State unemployment tax is a percent of taxable wages up to $9,500.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: 'Most employers typically pay 0.60% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 5.40% reduction, which brings the total rate to 0.60%. This is only paid on the first $7,000.00 of wages.',
      },
    ],
  },
  KS: {
    name: 'Kansas',
    short: 'KS',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 14000,
        label: 'Kansas State Unemployment Tax',
        tip: "State unemployment tax is a percent of taxable wages up to $14,000.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: 'Most employers typically pay 0.60% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 5.40% reduction, which brings the total rate to 0.60%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
    ],
  },
  KY: {
    name: 'Kentucky',
    short: 'KY',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 10200,
        label: 'KY Unemployment Tax',
        tip: "State unemployment tax is a percent of taxable wages up to $10,200.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: 'Most employers typically pay 0.60% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 5.40% reduction, which brings the total rate to 0.60%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
      {
        type: 'rate',
        rate: 0.0021,
        label: 'ME CSSF Tax',
        tip: "The UI Tax Surcharge is an adjustment to cover the funds that the state has borrowed from the Federal Government in order to fund the state's UI account. This adjustment affects all businesses operating in Kentucky and is 0.21% of taxable wages up to $10,200.00.",
        limit: 10200,
      },
    ],
  },
  LA: {
    name: 'Louisiana',
    short: 'LA',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 7700,
        label: 'LA Unemployment Insurance Tax',
        tip: "State unemployment tax is a percent of taxable wages up to $7,700.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: 'Most employers typically pay 0.60% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 5.40% reduction, which brings the total rate to 0.60%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
    ],
  },
  MA: {
    name: 'Massachusetts',
    short: 'MA',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 15000,
        label: 'MA Unemployment Insurance Tax',
        tip: "State unemployment tax is a percent of taxable wages up to $15,000.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: 'Most employers typically pay 0.60% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 5.40% reduction, which brings the total rate to 0.60%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
      {
        type: 'rate',
        rate: 0.00056,
        label: 'MA Workforce Training Tax',
        tip: 'The training fund provides resources to Massachusetts businesses to train current and newly hired employees. It is 0.056% of taxable wages up to $15,000.00.',
        limit: 15000,
      },
      {
        type: 'additional',
        label: 'MA EMAC',
        tip: 'The Employer Medical Assistance Contribution fund subsidizes health care to low-income residents of Massachusetts.',
      },
    ],
  },
  MD: {
    name: 'Maryland',
    short: 'MD',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 8500,
        label: 'MD Unemployment Tax',
        tip: "State unemployment tax is a percent of taxable wages up to $8,500.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: 'Most employers typically pay 0.60% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 5.40% reduction, which brings the total rate to 0.60%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
    ],
  },
  ME: {
    name: 'Maine',
    short: 'ME',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 12000,
        label: 'ME Unemployment Contributions',
        tip: "State unemployment tax is a percent of taxable wages up to $12,000.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: 'Most employers typically pay 0.60% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 5.40% reduction, which brings the total rate to 0.60%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
      {
        type: 'rate',
        rate: 0.0006,
        label: 'ME CSSF',
        tip: "Maine's Competitive Skills Scholarship Fund (CSSF) Tax funds programs to help workers learn new skills for high-wage jobs that are in demand in Maine. It is 0.06% of taxable wages up to $12,000.00.",
        limit: 12000,
      },
    ],
  },
  MI: {
    name: 'Michigan',
    short: 'MI',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 9000,
        label: 'MI State Unemployment Tax',
        tip: "State unemployment tax is a percent of taxable wages up to $9,000.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: 'Most employers typically pay 0.60% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 5.40% reduction, which brings the total rate to 0.60%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
      {
        type: 'additional',
        label: 'MI Obligation Assessment',
        tip: 'The MI Obligation Assessment is a tax administed by the UIA in partnership with the MI Dept. of Treasury to repay debt owed by the state to the United States Treasury.',
      },
    ],
  },
  MN: {
    name: 'Minnesota',
    short: 'MN',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 31000,
        label: 'MN Unemployment Tax',
        tip: "State unemployment tax is a percent of taxable wages up to $31,000.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: 'Most employers typically pay 0.60% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 5.40% reduction, which brings the total rate to 0.60%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
      {
        type: 'rate',
        rate: 0.001,
        label: 'MN Workforce Development Assessment',
        tip: 'Also known as the Workforce Enhancement Fee, this assessment is collected for the Minnesota Workforce Development Fund, which is used to fund programs that help unemployed workers with retraining and re-employment. It is 0.1% of $31,000.00.',
        limit: 31000,
      },
    ],
  },
  MO: {
    name: 'Missouri',
    short: 'MO',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 13000,
        label: 'MO Unemployment Insurance Tax',
        tip: "State unemployment tax is a percent of taxable wages up to $13,000.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: 'Most employers typically pay 0.60% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 5.40% reduction, which brings the total rate to 0.60%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
      {
        type: 'additional',
        label: 'MO Local Taxes',
        tip: 'This is an employer-paid tax administered by the city of St. Louis. It applies to both residents of St. Louis and non-residents working in St. Louis. It is used to pay for the general city services, like the police and fire departments, street repair, park maintenance and pay salaries for the city employees.',
      },
    ],
  },
  MS: {
    name: 'Mississippi',
    short: 'MS',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 14000,
        label: 'MS Unemployment Tax',
        tip: "State unemployment tax is a percent of taxable wages up to $14,000.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: 'Most employers typically pay 0.60% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 5.40% reduction, which brings the total rate to 0.60%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
      {
        type: 'rate',
        rate: 0.0016,
        label: 'MS Training Tax',
        tip: 'This tax supports the Mississippi Workforce Enhancement Training Fund to provide training, at no charge, to employers and employees in order to enhance employee productivity. It is 0.16% of taxable wages up to $14,000.00.',
        limit: 14000,
      },
    ],
  },
  MT: {
    name: 'Montana',
    short: 'MT',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 30500,
        label: 'MT Unemployment Insurace',
        tip: "State unemployment tax is a percent of taxable wages up to $30,500.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: 'Most employers typically pay 0.60% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 5.40% reduction, which brings the total rate to 0.60%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
      {
        type: 'additional',
        label: 'MT Administrative Fund Tax',
        tip: "Montana's Administrative Fund Tax (AFT) helps fund Department of Labor and Industry operations, including local Job Service.",
      },
    ],
  },
  NC: {
    name: 'North Carolina',
    short: 'NC',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 22300,
        label: 'NC Unemployment Tax',
        tip: "State unemployment tax is a percent of taxable wages up to $22,300.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: 'Most employers typically pay 0.60% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 5.40% reduction, which brings the total rate to 0.60%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
    ],
  },
  ND: {
    name: 'North Dakota',
    short: 'ND',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 37200,
        label: 'North Dakota State Unemployment Tax',
        tip: "State unemployment tax is a percent of taxable wages up to $37,200.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: 'Most employers typically pay 0.60% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 5.40% reduction, which brings the total rate to 0.60%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
    ],
  },
  NE: {
    name: 'Nebraska',
    short: 'NE',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 9000,
        label: 'NE SUIT',
        tip: "State unemployment tax is a percent of taxable wages up to $9,000.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: 'Most employers typically pay 0.60% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 5.40% reduction, which brings the total rate to 0.60%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
    ],
  },
  NH: {
    name: 'New Hampshire',
    short: 'NH',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 14000,
        label: 'NH Unemployment Insurance',
        tip: "State unemployment tax is a percent of taxable wages up to $14,000.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: 'Most employers typically pay 0.60% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 5.40% reduction, which brings the total rate to 0.60%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
      {
        type: 'rate',
        rate: 0.002,
        label: 'NH Administrative Contribution',
        tip: 'The Administrative Contribution (AC) is used to fund staffing and operation of the unemployment offices in New Hampshire. It is 0.2% of taxable wages up to $14,000.00',
        limit: 14000,
      },
    ],
  },
  NJ: {
    name: 'New Jersey',
    short: 'NJ',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 32600,
        label: 'NJ Employer SUI',
        tip: "State unemployment tax is a percent of taxable wages up to $32,600.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: 'Most employers typically pay 0.60% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 5.40% reduction, which brings the total rate to 0.60%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
      {
        type: 'rate',
        rate: 0.005,
        label: 'NJ Employer SDI',
        tip: 'The New Jersey State Disability Insurance (SDI) Tax funds the State Disability Program which provides temporary benefit payments to employees for non work-related disabilities. It is 0.5% of taxable wages up to $32,600.00.',
        limit: 32600,
      },
      {
        type: 'rate',
        rate: 0.001175,
        label: 'NJ WF/SWF',
        tip: 'The Workforce Development Tax is paid by all New Jersey employees and funds state career training and education programs. It is 0.1175% of taxable wages up to $32,600.00.',
        limit: 32600,
      },
      {
        type: 'additional',
        label: 'NJ Local Taxes',
        tip: 'All businesses in the city of Newark have to pay an additional flat-rate tax to the city, to cover business processes and administration expenses.',
      },
    ],
  },
  NM: {
    name: 'New Mexico',
    short: 'NM',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 24100,
        label: 'NM Unemployment Insurance Tax',
        tip: "State unemployment tax is a percent of taxable wages up to $24,100.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: 'Most employers typically pay 0.60% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 5.40% reduction, which brings the total rate to 0.60%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
      {
        type: 'constant',
        value: 2.3,
        label: "NM Workers' Compensation Fee",
        tip: "Employers covered by the NM workers' compensation law are required to pay this fee to support NM Workers' Compensation Administration. It is $2.30 per employee.",
      },
    ],
  },
  NV: {
    name: 'Nevada',
    short: 'NV',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 28200,
        label: 'Nevada State Unemployment Tax',
        tip: "State unemployment tax is a percent of taxable wages up to $28,200.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: 'Most employers typically pay 0.60% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 5.40% reduction, which brings the total rate to 0.60%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
      {
        type: 'rate',
        rate: 0.0005,
        label: 'Nevada Career Enhancement Program',
        tip: 'Also called CEP. It is paid on a quarterly basis, along with Unemployment Insurance. You may have a non-zero liability here. It is 0.05% of taxable wages up to $28,200.00.',
        limit: 28200,
      },
      {
        type: 'additional',
        label: 'Nevada Bond Surcharge',
        tip: 'Also called NV Bond Tax. It is a new employer tax (since January 2014) that covers the costs on bonds issued by the State of Nevada for repaying federal loans. You may have a non-zero liability here.',
      },
      {
        type: 'additional',
        label: 'Nevada MBT Financial Institution',
        tip: 'Also called MBT. This tax is a flat-percentage employer tax that is paid on a quarterly basis. You may have a non-zero liability here',
      },
      {
        type: 'additional',
        label: 'Nevada MBT General Business',
        tip: 'Also called MBT. This tax is a flat-percentage employer tax that is paid on a quarterly basis. You may have a non-zero liability here.',
      },
    ],
  },
  NY: {
    name: 'New York',
    short: 'NY',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 10700,
        label: 'NY SUI',
        tip: "State unemployment tax is a percent of taxable wages up to $10,700.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: 'Most employers typically pay 0.60% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 5.40% reduction, which brings the total rate to 0.60%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
      {
        type: 'rate',
        rate: 0.00075,
        label: 'NY Reemployment',
        tip: 'The Reemployment Tax is a mandatory tax that is added to the State unemployment tax at a rate of 0.075% of taxable wages up to $10,700.00',
        limit: 10700,
      },
      {
        type: 'additional',
        label: 'NY MCTMT',
        tip: 'Employers with sufficiently large payrolls that employ workers within the metropolitan commuter transportation district are required to pay this tax.',
      },
    ],
  },
  OH: {
    name: 'Ohio',
    short: 'OH',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 9000,
        label: 'Ohio State Unemployment Tax',
        tip: "State unemployment tax is a percent of taxable wages up to $9,000.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.021,
        label: 'FUTA',
        tip: 'Most employers typically pay 2.10% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 3.90% reduction, which brings the total rate to 2.10%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
    ],
  },
  OK: {
    name: 'Oklahoma',
    short: 'OK',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 17500,
        label: 'OK Unemployment Compensation Tax',
        tip: "State unemployment tax is a percent of taxable wages up to $17,500.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: 'Most employers typically pay 0.60% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 5.40% reduction, which brings the total rate to 0.60%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
    ],
  },
  OR: {
    name: 'Oregon',
    short: 'OR',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 36900,
        label: 'OR Unemployment Insurance',
        tip: "State unemployment tax is a percent of taxable wages up to $36,900.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: "State unemployment tax is a percent of taxable wages up to $36,900.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
        limit: 7000,
      },
      {
        type: 'additional',
        label: "OR Workers' Benefit Fund",
        tip: "Also called Workers' Benefit Fund (WBF) Assessment, this tax funds programs that encourage the reemployment of previously injured or handicapped workers, and gives financial aid to permanently disabled workers and their families. It is calculated as a flat rate per employee hour worked and is split between employees and employers. This is the employer portion of this tax.",
      },
      {
        type: 'additional',
        label: 'OR Local Taxes',
        tip: 'The transit tax funds local public transportation and transportation safety programs. It is mandatory to employers of certain cities, and is calculated as a percentage of wages.',
      },
    ],
  },
  PA: {
    name: 'Pennsylvania',
    short: 'PA',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 9500,
        label: 'PA UC Tax Employer Contribution',
        tip: "tate unemployment tax is a percent of taxable wages up to $9,500.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: 'Most employers typically pay 0.60% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 5.40% reduction, which brings the total rate to 0.60%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
      {
        type: 'additional',
        label: 'PA Local Taxes',
        tip: 'The City of Pittsburgh levies a Payroll Expense Tax on employers which is separate from the Earned Income Tax (EIT) or Local Services Tax (LST) that the employer withholds from the earnings of employees. The tax is assessed at a rate of 0.55% payroll earned in Pittsburgh.',
      },
    ],
  },
  RI: {
    name: 'Rhode Island',
    short: 'RI',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 22000,
        label: 'RI Employment Security Taxes',
        tip: "State unemployment tax is a percent of taxable wages up to $22,000.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: 'Most employers typically pay 0.60% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 5.40% reduction, which brings the total rate to 0.60%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
      {
        type: 'rate',
        rate: 0.0021,
        label: 'RI Job Development Assessment',
        tip: "This employer surcharge funds the Governor's Workforce Board, which provides various job training, counseling and assessment services to develop Rhode Island's workforce to meet the future needs of employers. It is 0.21% of taxable wages up to $22,000.00.",
        limit: 22000,
      },
    ],
  },
  SC: {
    name: 'South Carolina',
    short: 'SC',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 14000,
        label: 'SC Unemployement Tax',
        tip: "State unemployment tax is a percent of taxable wages up to $14,000.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: 'Most employers typically pay 0.60% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 5.40% reduction, which brings the total rate to 0.60%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
      {
        type: 'rate',
        rate: 0.0006,
        label: 'SC Contingency Assessment (DACA)',
        tip: 'The Contingency Assessment is a mandatory surcharge that is added to the state unemployment tax. It is 0.06% of taxable wages up to $14,000.00.',
        limit: 14000,
      },
    ],
  },
  SD: {
    name: 'South Dakota',
    short: 'SD',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 15000,
        label: 'SD UI Contributions',
        tip: "State unemployment tax is a percent of taxable wages up to $15,000.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: 'Most employers typically pay 0.60% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 5.40% reduction, which brings the total rate to 0.60%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
      {
        type: 'additional',
        label: 'SD Investment Fee',
        tip: "The Investment Fee is a component of Unemployment Insurance (UI) tax that funds the Governor's office of Economic Development.",
      },
    ],
  },
  TN: {
    name: 'Tennessee',
    short: 'TN',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 8000,
        label: 'TN Unemployment Insurance Premiums',
        tip: "State unemployment tax is a percent of taxable wages up to $8,000.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: 'Most employers typically pay 0.60% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 5.40% reduction, which brings the total rate to 0.60%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
    ],
  },
  TX: {
    name: 'Texas',
    short: 'TX',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 9000,
        label: 'TX SUTA',
        tip: "State unemployment tax is a percent of taxable wages up to $9,000.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: 'Most employers typically pay 0.60% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 5.40% reduction, which brings the total rate to 0.60%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
    ],
  },
  UT: {
    name: 'Utah',
    short: 'UT',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 32200,
        label: 'UT Unemployment Insurance Tax',
        tip: "State unemployment tax is a percent of taxable wages up to $32,200.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: 'Most employers typically pay 0.60% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 5.40% reduction, which brings the total rate to 0.60%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
    ],
  },
  VA: {
    name: 'Virginia',
    short: 'VA',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 8000,
        label: 'VA Unemployment Insurance Tax',
        tip: "State unemployment tax is a percent of taxable wages up to $8,000.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: 'Most employers typically pay 0.60% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 5.40% reduction, which brings the total rate to 0.60%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
    ],
  },
  VT: {
    name: 'Vermont',
    short: 'VT',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 16800,
        label: 'VT Unemployment Insurance',
        tip: "State unemployment tax is a percent of taxable wages up to $16,800.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: 'Most employers typically pay 0.60% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 5.40% reduction, which brings the total rate to 0.60%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
      {
        type: 'constant',
        value: 151.12,
        label: '-',
        tip: "This employer surcharge funds the Governor's Workforce Board, which provides various job training, counseling and assessment services to develop Rhode Island's workforce to meet the future needs of employers. It is 0.21% of taxable wages up to $22,000.00.",
      },
    ],
  },
  WA: {
    name: 'Washington',
    short: 'WA',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 44000,
        label: 'WA SUI',
        tip: "State unemployment tax is a percent of taxable wages up to $44,000.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: 'Most employers typically pay 0.60% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 5.40% reduction, which brings the total rate to 0.60%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
      {
        type: 'additional',
        label: 'WA EAF',
        tip: 'The Washington Employment Administration Fund tax finance work-search assistance and training for the unemployed. It is either 0.02% or 0.03%.',
      },
      {
        type: 'additional',
        label: "WA Workers' Comp Insurance",
        tip: "The employer-paid portion of the Washington Workers' Comp. Insurance tax. The rate is based on the risk class of the work performed.",
      },
    ],
  },
  WI: {
    name: 'Wisconsin',
    short: 'WI',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 14000,
        label: 'WI Unemployment Insurance Tax',
        tip: "State unemployment tax is a percent of taxable wages up to $14,000.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: 'Most employers typically pay 0.60% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 5.40% reduction, which brings the total rate to 0.60%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
    ],
  },
  WV: {
    name: 'West Virginia',
    short: 'WV',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 12000,
        label: 'West Virginia State Unemployment Tax',
        tip: "State unemployment tax is a percent of taxable wages up to $12,000.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: 'Most employers typically pay 0.60% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 5.40% reduction, which brings the total rate to 0.60%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
    ],
  },
  WY: {
    name: 'Wyoming',
    short: 'WY',
    items: [
      {
        type: 'rate',
        label: 'Social Security Tax',
        tip: 'You pay 6.2% of wages, up until an employee reaches $118,500.00 in earnings.',
        rate: 0.062,
        limit: 118000,
      },
      {
        type: 'rate',
        label: 'Medicare Tax',
        tip: 'You pay 1.45% of wages. There is no wage limit.',
        rate: 0.0145,
      },
      {
        type: 'sui',
        base: 25500,
        label: 'WY Unemployment Insurance',
        tip: "State unemployment tax is a percent of taxable wages up to $25,500.00. The rate is determined using an employer's experience rating and the amount of funds in the UI account.",
      },
      {
        type: 'rate',
        rate: 0.006,
        label: 'FUTA',
        tip: 'Most employers typically pay 0.60% of wages. The rate is actually 6.0%, but if you are paying state unemployment tax then you qualify for a 5.40% reduction, which brings the total rate to 0.60%. This is only paid on the first $7,000.00 of wages.',
        limit: 7000,
      },
      {
        type: 'additional',
        label: "WY Workers' Compensation",
        tip: "The employer-paid Wyoming Workers' Compensation rate is based on the risk class of the work performed.",
      },
    ],
  },
};

const parseRateTax = (annualWage, rateTaxData) => {
  const { rate, limit, ...rest } = rateTaxData;

  const parsedAnnualWage =
    typeof limit !== 'undefined' ? Math.min(annualWage, limit) : annualWage;

  return {
    calculated: Number((parsedAnnualWage * rate).toFixed(4)),
    ...rest,
  };
};

const parseSuiTax = (annualWage, suiRate, suiTaxData) => {
  const { base, ...rest } = suiTaxData;

  if (annualWage < base) {
    return {
      calculated: Number((annualWage * (suiRate / 100)).toFixed(4)),
      ...rest,
    };
  }
  return {
    calculated: Number((base * (suiRate / 100)).toFixed(4)),
    ...rest,
  };
};

const parseConstantTax = (constantTaxData) => {
  const { value, ...rest } = constantTaxData;
  return {
    calculated: Number(value.toFixed(4)),
    ...rest,
  };
};

export default {
  init(instance) {
    document.addEventListener('alpine:init', () => {
      instance.data('TaxCalculatorForm', () => ({
        inputs: {
          entity_state: '',
          annual_wage: '',
          sui_rate: '',
        },
        errors: {},
        results: {
          items: [
            {
              type: '-',
              calculated: 0,
              label: '-',
            },
          ],
          totalAmount: 0,
        },
        calculateTaxes() {
          if (!this.inputs.entity_state) {
            return;
          }
          const state = TaxCalculatorForm[this.inputs.entity_state];
          const parsedItems = state.items
            .filter((item) => this.inputs.sui_rate ? true : item.type !== 'sui')
            .map((item) => {
              if (item.type === 'additional') return item;
              if (item.type === 'constant') return parseConstantTax(item);
              return item.type === 'sui'
                ? parseSuiTax(
                    Number(this.inputs.annual_wage),
                    Number(this.inputs.sui_rate) ?? 0,
                    item,
                  )
                : parseRateTax(Number(this.inputs.annual_wage), item);
            });

          const totalTaxes = parsedItems
            .filter((item) => item.type !== 'additional')
            .reduce((pv, cv) => pv + cv.calculated, 0);

          const totalAmount = Number(this.inputs.annual_wage) + totalTaxes;

          this.results = {
            ...state,
            items: parsedItems,
            totalAmount,
          };
        },
        validateField(fieldName, skipDeleteErr = false) {
          if (!skipDeleteErr) delete this.errors[fieldName];

          if (
            fieldName === 'sui_rate' &&
            (Number(this.inputs[fieldName]) < 0 ||
              Number(this.inputs[fieldName]) > 100)
          ) {
            this.errors[fieldName] =
              'Please enter a valid rate between 0 and 100.';
          }
          if (
            fieldName &&
            fieldName !== 'sui_rate' &&
            (Number(this.inputs[fieldName]) <= 0 || !this.inputs[fieldName])
          ) {
            this.errors[fieldName] = 'Annual Wage must be a valid number.';
          }
        },
        validateAll() {
          this.validateField('entity_state', true);
          this.validateField('annual_wage', true);
          this.validateField('sui_rate', true);
        },
        submit() {
          this.errors = {};
          this.inputs.annual_wage =
            document.getElementById('annual_wage').value;
          this.inputs.sui_rate = document.getElementById('sui_rate').value;
          this.validateAll();
          if (Object.keys(this.errors).length > 0) {
            return;
          }
          this.calculateTaxes();
        },
      }));
    });
  },
};
